import request from '@/services/request'

export function getTableSyncList() {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/table-sync/common-list',
    method: 'get'
  })
}





// WEBPACK FOOTER //
// ./src/api/table_sync.js